import { AppLayout, BreadcrumbGroup } from '@amzn/awsui-components-react';
import React, { useState, useEffect } from 'react';
import { Navbar } from '../../utils/Navbar';
import { Sidebar } from '../../utils/sidebar';
import { tumblerNavbarOptions } from '../../tumblerConstants';
import {SoftwareUpdateTrackerDetails} from '../../sdpds/application/SoftwareUpdateTracker/Details/SoftwareUpdateTrackerDetails';
import { apiCall, getDefaultStack } from '../../sdpds/utils';

const SoftwareUpdateTracker = () => {
  const [navigationOpen, setNavigationOpen] = useState(false);
  const [stackName, setStackName] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchDefaultStack = async () => {
      try {
        const config = await apiCall('/getConfig', {});
        if (config.statusCode === 200) {
          const defaultStack = getDefaultStack(config.body);
          setStackName(defaultStack);
        }
      } catch (err) {
        console.error('Failed to fetch default stack:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDefaultStack();
  }, []);

  return (
    <div className="awsui">
      <Navbar
        title={'Software Update Tracker'}
        homeUrl="/software-update-tracker"
        regionSwitcherActive={true}
        dropdownOptions={tumblerNavbarOptions}
      />
      <div style={{ paddingTop: '60px' }}>
        <AppLayout
          disableContentPaddings={false}
          content={
            isLoading ? (
              <div>Loading...</div>
            ) : (
              <SoftwareUpdateTrackerDetails
                stackName={stackName}
                isSDPDSMetric={true}
              />
            )
          }
          toolsHide={true}
          navigation={<Sidebar />}
          navigationOpen={navigationOpen}
          onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
          headerSelector="#navbar"
          breadcrumbs={<BreadcrumbGroup items={[]} ariaLabel="Breadcrumbs" />}
        />
      </div>
    </div>
  );
};

export { SoftwareUpdateTracker };